import { CSSProperties } from 'react'
import { Theme } from '../../theme'

// Theme tokens handed to pagination.module.scss as CSS variables.
export const getItemVars = (theme: Theme) =>
  ({
    '--pagination-item-size': theme.spacing.xl,
    '--pagination-item-radius': theme.radii.interactive,
    '--pagination-item-color': theme.semantic.contentSecondary,
    '--pagination-item-font-size': theme.typographyTokens.bodySm.fontSize,
    '--pagination-item-font-weight': theme.typographyTokens.bodySm.fontWeight,
    '--pagination-item-line-height': theme.typographyTokens.bodySm.lineHeight,
    '--pagination-item-hover-bg': theme.semantic.interactiveSecondaryHover,
    '--pagination-item-hover-color': theme.semantic.contentPrimary,
    '--pagination-item-focus-border': theme.semantic.interactiveFocus,
    '--pagination-item-active-bg': theme.semantic.backgroundBrandSubtle,
    '--pagination-item-active-color': theme.semantic.contentBrand,
    '--pagination-item-disabled-color': theme.semantic.contentDisabled,
  } as CSSProperties)
